export default __webpack_public_path__ + "static/media/image80.56b0e90a.svg";